import { Box, Flex, Text } from "@chakra-ui/react";
import { IconLiveries } from "icons";
import { ReactNode } from "react";

interface UpgradeCarItemProps {
  children?: ReactNode;
  icon: ReactNode;
  title: string;
  subtitle?: string;
  backgroundGradient: string;
  borderGradient: string;
}

const UpgradeCarItem = ({ 
  children, 
  title, 
  subtitle, 
  backgroundGradient,
  borderGradient,
  icon 
}: UpgradeCarItemProps) => {
  return (
    <Flex
      position="relative"
      background="linear-gradient(180deg, #1E2023 0%, #17181A 100%)"
      style={{
        backgroundOrigin: 'border-box',
      }}
      w="full"
      h="116px"
      borderRadius="4px"
      _before={{
        content: '""',
        position: 'absolute',
        inset: 0,
        padding: '1.5px',
        background: borderGradient,
        borderRadius: '4px',
        mask: "linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0)",
        maskComposite: "exclude",
      }}
    >
      <Box 
        background={backgroundGradient}
        position="absolute"
        inset={0}
        borderRadius="4px"
      />
      <Flex 
        flexDir="column"
        gap="0.25rem" 
        w="full"
        p="0.5rem"
        alignItems="center"
        justifyContent="flex-start"
        pt="1rem"
      >
        {icon}
        
        <Flex flexDir="column" gap="0" alignItems="center">
          <Text
            fontSize={{ base: '0.75rem', md: '1rem' }}
            lineHeight={{ base: '1.125rem', md: '1.5rem' }}
            fontWeight="600"
            color="white.95"
          >
            {title}
          </Text>

          <Text
            fontSize={{ base: '0.625rem', md: '0.75rem' }}
            lineHeight={{ base: '0.75rem', md: '0.875rem' }}
            fontWeight="500"
            color="white.80"
            whiteSpace="pre-line"
            textAlign="center"
          >
            {subtitle}
          </Text>
          {children}
        </Flex>
      </Flex>
    </Flex>
  )
}

export default UpgradeCarItem;